export const Colors = {
  purpleSequence: ['#7E57C2', '#9575CD', '#B39DDB', '#D1C4E9', '#EDE7F6'],
};
